<template>
  <div class="category-box" v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0)">
    <div id="scrollBox" ref="scrollBox" class="category-list">
      <div ref="scrollContent" class="category-list-content">
        <div v-for="(item, index) in groupList" :key="item.id" class="item" :class="{ active: groupId == item.id }">
          <div class="item-inner">
            <div @click="changeGroup(item.id)">
              <span v-if="index > 0 && groupList.length > 1">【已归档】</span>
              <span>
                {{ item.record_time }}
                <template v-if="groupId == item.id && sceneList.length">（{{ sceneList.length }}）</template>
              </span>
            </div>
            <i v-if="index == 0" @click="editGroup(item)" class="el-icon-edit v-ml-5"></i>
            <i v-if="index == 0 && groupList.length > 1" @click="deleteGroup(item)" class="el-icon-delete v-ml-5"></i>
          </div>
        </div>
      </div>
    </div>
    <header-group-edit v-if="isShowGroupEdit" :show.sync="isShowGroupEdit" :row="row" />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import headerGroupEdit from './header-group-edit';
import IScroll from 'iscroll';

export default {
  components: { headerGroupEdit },

  data() {
    return {
      row: null,
      isShowGroupEdit: false,
      worksId: this.$route.query.id,
    };
  },

  computed: {
    ...mapState('tour', ['krp', 'groupList', 'groupId', 'materialId', 'sceneList']),
    loading() {
      return this.groupList.length == 0;
    },
  },

  watch: {
    groupList() {
      this.$nextTick(() => {
        this.calculateScroll();
      });
    },
  },

  methods: {
    ...mapMutations('tour', {
      mutationSetGroupId: 'SET_GROUP_ID',
      mutationSetMaterialId: 'SET_MATERIAL_ID',
      mutationSetSceneList: 'SET_SCENE_LIST',
    }),

    ...mapActions('tour', {
      actionGetGroupList: 'getGroupList',
      actionGetSceneList: 'getSceneList',
      actionGetSceneDetail: 'getSceneDetail',
      actionLoadKrp: 'loadKrp',
    }),

    //加载滚动条
    calculateScroll() {
      if (this.myScroll) {
        this.myScroll.refresh();
      } else {
        this.myScroll = new IScroll('#scrollBox', {
          scrollX: true,
          scrollY: false,
          scrollbars: true,
          mouseWheel: true,
          interactiveScrollbars: true,
        });
      }
    },

    //修改分组
    editGroup(row) {
      this.row = row;
      this.isShowGroupEdit = true;
    },

    async changeGroup(groupId) {
      let fromScene = this.sceneList.find((item) => item.id == this.materialId);
      let topId = fromScene.top_id || fromScene.id;
      this.mutationSetGroupId(groupId);
      this.mutationSetSceneList([]);
      let sceneList = await this.actionGetSceneList({ worksId: this.worksId, groupId: this.groupId });
      let matchScene = sceneList.find((item) => item.top_id == topId || (item.top_id == 0 && item.id == topId));
      let materialId = matchScene ? matchScene.id : sceneList[0].id;
      this.mutationSetMaterialId(materialId);
      let sceneDetail = await this.actionGetSceneDetail({ worksId: this.worksId, materialId: this.materialId });
      this.actionLoadKrp({ krp: this.krp, sceneDetail });
      this.$nextTick(() => {
        this.calculateScroll();
      });
    },

    async deleteGroup({ id }) {
      try {
        await this.$confirm('确认删除?', '提示', { type: 'warning' });
        await this.api.group.delete({ id });
        this.$message.success('删除成功');
        this.mutationSetGroupId(0);
        await this.actionGetGroupList(this.worksId);
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.category-box {
  display: flex;
  flex: 1;
  margin-right: 10px;
  overflow: hidden;
  align-items: center;
  position: relative;
}

.category-list {
  flex: 1;
  box-sizing: content-box;
  color: #fff;
  font-size: 12px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  .category-list-content {
    display: inline-block;
    white-space: nowrap;
  }

  .item {
    display: inline-block;
    cursor: pointer;
    position: relative;
    box-sizing: border-box;
    margin-right: 15px;
    padding-right: 15px;
  }

  .item .view {
    font-size: 12px;
    margin-right: 3px;
    position: relative;
    top: 1px;
  }

  .item-inner {
    display: flex;
    position: relative;
    align-items: center;
    flex-shrink: 0;
    height: 32px;
  }

  .item:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    height: 10px;
    width: 1px;
    background: #fff;
  }

  .item:last-child:after {
    display: none;
  }

  .item .category-operate {
    cursor: pointer;
    position: relative;
    z-index: 100;
  }

  .item.active {
    color: #409eff;
  }

  .operate {
    margin-left: 5px;
    display: none;
    color: #fff;
  }

  .operate:hover {
    color: #409eff;
  }

  .item:hover .operate {
    display: inline;
  }
}

.category-add {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
  cursor: pointer;
  user-select: none;
  font-size: 12px;
  padding: 2px 10px;
  border-radius: 4px;
  flex-shrink: 0;
  margin-right: 15px;
}

.category-all {
  font-size: 12px;
  width: 39px;
  display: flex;
  align-items: center;
  position: relative;
  margin-right: 15px;
  cursor: pointer;
}

.category-all:after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  height: 10px;
  width: 1px;
  background: #fff;
}

.category-all.active {
  color: #409eff;
}
</style>
